import { render, staticRenderFns } from "./ProductsSector.vue?vue&type=template&id=09ff76b9&scoped=true&"
import script from "./ProductsSector.vue?vue&type=script&lang=js&"
export * from "./ProductsSector.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSector.vue?vue&type=style&index=0&id=09ff76b9&scoped=true&lang=css&"
import style1 from "./ProductsSector.vue?vue&type=style&index=1&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ff76b9",
  null
  
)

export default component.exports